// extracted by css-extract-rspack-plugin
export default {"container":"container-k3N_bL"};